import styled from "styled-components";
import { createGradientOrSolid } from "../../Helper/utils";

export const StyledMainSubBundle = styled.div`
    height: 200px;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    border-radius: 15px;
    padding: 3px;
    background: ${(props: any) => createGradientOrSolid(props.bundleBorderColor)};
    font-family: ${(props: any) => props.fontFamily};
    position: relative;

    .container {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .products {
        min-height: calc(100% - 30px);
        border-radius: 15px 15px 0 0;
        display: flex;
        flex-direction: column;
        background: ${(props: any) =>
            props.backgroundSrc
                ? `url("${props.backgroundSrc}")`
                : createGradientOrSolid(props.backgroundColor)};
        background-size: 100% 100%;

        & > div {
            width: 100%;

            &.main {
                height: 100%;
            }

            &.sub {
                min-height: 100px;
                max-height: 100px;
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                position: relative;
                padding: 4px;
            }
        }
    }

    span {
        text-shadow: 0px 2px 0px #000000;
        color: ${(props: any) => props.textColor};

        &.availability{
            position: absolute;
            bottom: 10px;
            font-size: 12px;
            font-weight: 600;

            &.quantity {
                left: 15px;
            }
        }
    }
` as any;

export const StyledMainProduct = styled.div`
    height: 100%;
    width: 100%;
    padding-left: 16px;
    display: flex;
    align-items: center;

    img {
        object-fit: contain;

        &.mainPic {
            height: 62px;
            width: 62px;
            position: relative;
            top: -10px;
        }
        
        &.prefixPic {
            height: 18px;
            width: 18px;
        }
    }

    .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 25%;
        margin-left: 8px;
        position: relative;
        z-index: 1;

        & > div {
            display: flex;
            gap: 8px;
        }

        p {
            margin: 0;
            text-align: center;

            &.quantity {
                font-size: 16px;
                font-weight: 700;
                background: linear-gradient(to bottom, rgb(255, 247, 199), rgb(226, 182, 109));
                background-clip: text;
                -webkit-background-clip: text;
                -moz-background-clip: text;
                -moz-text-fill-color: transparent;
                -webkit-text-fill-color: transparent;
                position: relative;

                &:after {
                    background: none;
                    content: "${(props: any) => props.title}";
                    left: 0;
                    top: 0;
                    z-index: -1;
                    position: absolute;
                    text-shadow: 0 2px 0px #000000;
                }
            }

            &.stroked {
                font-size: 12px;
                font-weight: 600;
                color: white;
                position: relative;
                text-shadow: 0 2px black;

                &::after {
                    content: ' ';
                    height: 2px;
                    width: 100%;
                    background: #D8232A;
                    position: absolute;
                    left: 0;
                    top: 50%;
                }
            }
        }
    }

    @media (min-width: 375px) {
        padding-left: 24px;

        img {
            &.mainPic {
                transform: scale(1.2);
            }
            
            &.prefixPic {
                height: 22px;
                width: 22px;
            }
        }

        .text {
            margin-left: 16px;

            p {
                &.quantity {
                    font-size: 20px;
                }

                &.stroked {
                    font-size: 14px;
                }
            }
        }
    }
` as any;

export const StyledSubProduct = styled.div`
    margin-right: 4px;
    width: fit-content;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding-left: ${(props: any) => props.isBadged ? "6px" : "0" };

    .content-container {
        height: 77%;
        display: flex;
        align-items: center;

        p {
            padding-left: ${(props: any) => props.isBadged ? "0" : "6px" };
            margin: 0 0 0 4px;
            font-size: 14px;
            font-weight: 600;
            color: ${(props: any) => props.color};

            &.tooltip {
                font-size: 12px;
                font-weight: 400;
                img {
                    height: 8px;
                }
            }
        }
    }

    img {
        aspect-ratio: 1/1;
        object-fit: contain;
    }

    .product-image-container {
        height: 100%;
        width: 100%;
        max-width: 35px;
        position: relative;

        .product {
            height: 100%;
            position: relative;
            z-index: 2;
        }
        .badge {
            height: 22px;
            width: 40px;
            display: flex;
            align-items: center;
            position: absolute;
            right: 50%;
            top: 55%;
            z-index: 1;
            transform: translateY(-50%);
            background-image: url("https://media.appcharge.com/defaults/product-badge-huge.png");
            background-size: cover;
            h4 {
                position: relative;
                font-size: 14px;
                padding-left: 8px;
                font-weight: 600;
                background: -webkit-linear-gradient(rgb(255, 247, 199), rgb(226, 182, 109));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                &:after {
                    background: none;
                    content: "${(props: any) => props.badgeText}";
                    padding-left: 8px;
                    left: 0;
                    top: 0;
                    z-index: -1;
                    position: absolute;
                    text-shadow: 0 1px 0px #000000;
                }
            }
        }
        .tooltip {
            height: 8px;
            width: 8px;
            position: absolute;
            top: 0;
            left: 0;
            transform: translateY(-100%);
        }
    }

    @media (min-width: 375px) {
        .product-image-container .tooltip {
            height: 10px;
            width: 10px;
        }
    }
` as any;
